import React from "react";
import {
  Trash,
  WarningCircle,
} from "@phosphor-icons/react";

import ActaModal from "@/components/ui/ActaModal";

export default function ContactDeleteConfirmModal({
  open,
  contactLabel,
  dependencies = [],
  deleting = false,
  onClose,
  onConfirm,
}) {
  const hasDependencies =
    Array.isArray(dependencies) &&
    dependencies.length > 0;

  return (
    <ActaModal
      open={open}
      onClose={onClose}
      eyebrow="Suppression"
      title={`Supprimer ${contactLabel || "ce contact"} ?`}
      subtitle="Vérifiez les conséquences avant de confirmer."
      size="sm"
      closeDisabled={deleting}
      closeOnOverlay={!deleting}
      closeOnEscape={!deleting}
      testId="contact-delete-confirm-modal"
      footer={
        <div className="flex w-full items-center justify-center gap-4">
          <button
            type="button"
            className="au-btn-ghost min-h-[42px] px-4"
            onClick={onClose}
            disabled={deleting}
          >
            Annuler
          </button>

          <button
            type="button"
            className="inline-flex min-h-[42px] items-center justify-center gap-2 rounded-xl bg-[var(--do-rose)] px-4 font-bold text-white transition hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-55"
            onClick={onConfirm}
            disabled={deleting}
            data-testid="contact-delete-confirm-action"
          >
            <Trash
              size={17}
              weight="bold"
            />
            {deleting
              ? "Suppression…"
              : "Supprimer"}
          </button>
        </div>
      }
    >
      <div className="space-y-4">
        <div className="flex gap-3 rounded-2xl border border-[var(--do-border)] bg-[var(--do-bg-2)] p-4">
          <WarningCircle
            size={22}
            weight="fill"
            className="mt-0.5 shrink-0 text-[var(--do-rose)]"
          />

          <div className="space-y-1">
            <p className="text-sm font-bold text-[var(--do-ink)]">
              Cette action supprimera définitivement la fiche contact.
            </p>

            <p className="text-sm leading-6 text-[var(--do-muted)]">
              Les rendez-vous, notes et données de travail directement
              liés au contact seront également nettoyés.
            </p>
          </div>
        </div>

        {hasDependencies ? (
          <div>
            <p className="mb-2 text-sm font-bold text-[var(--do-ink)]">
              Éléments métier qui seront archivés
            </p>

            <div className="space-y-2">
              {dependencies.map(
                (dependency) => (
                  <div
                    key={dependency.key || dependency.label}
                    className="flex items-center justify-between rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-3 py-2.5"
                  >
                    <span className="text-sm font-semibold text-[var(--do-ink)]">
                      {dependency.label}
                    </span>

                    <span className="rounded-full bg-[var(--do-accent-soft)] px-2.5 py-1 text-xs font-black text-[var(--do-accent)]">
                      {dependency.count}
                    </span>
                  </div>
                )
              )}
            </div>
          </div>
        ) : (
          <p className="text-sm leading-6 text-[var(--do-muted)]">
            Aucun élément métier actif lié ne nécessite d’archivage.
          </p>
        )}
      </div>
    </ActaModal>
  );
}
